enum EventType {
    ERROR = "ERROR",
    SUCCESS = "SUCCESS",
    INFO = "INFO",
    TOAST_ERROR = "TOAST_ERROR",
    TOAST_SUCCESS = "TOAST_SUCCESS",
    TOAST_INFO = "TOAST_INFO"

}
export default EventType;